import {Injectable} from '@angular/core';
import {environment} from "../../environments/environment";
import {Observable} from "rxjs";
import {Perfil} from "../models/perfil";
import {map} from "rxjs/operators";
import {HttpClient} from "../../../node_modules/@angular/common/http";

@Injectable({
	providedIn: 'root'
})
export class PerfilService {

	private api_url = environment.api_url + "/perfil";

	constructor(private http: HttpClient) {

	}

	listAll(): Observable<Perfil[]> {
		let url: string = this.api_url;
		return this.http.get(url).pipe(map((res: any) => {
			return res.data as Array<Perfil>;
		}));
	}
}
